import WidgetSnippetForm from './WidgetSnippetForm';

export default WidgetSnippetForm;